<template>
  <div class="main" style="width:100vw">
    <van-swipe  v-if="showSkuImgList && showSkuImgList.length > 0" class="my-swipe" :autoplay="5000" indicator-color="white" @change="onChange">
      <van-swipe-item  v-for="(img, index) in showSkuImgList" :key="index">
        <img class="swipe-image" v-lazy="img"  />
      </van-swipe-item>
      <template class="indicator" #indicator>
        <div class="custom-indicator">{{ current + 1 }}/{{imgNumber}}</div>
      </template>
    </van-swipe>
    <div class="goods-title">
      <div class="title" ref="goods_detail">{{skuGoodsInfo.sellerProductTitle}}</div>
      <div class="show-price" v-if="showPrice">
        <div class="pr" v-show="showPrice != '价格详谈'">¥</div>
        <div class="price-number">{{showPrice}}</div>
      </div>
      <table class="spec-detail" ref="spec_detail">
        <tr class='table-tr' v-for="(item,index) in skuGoodsInfo.sellerProductSkuDisplayDtoList" :key="index" @click="selectSkuSpec">
          <td class="spec-title" ref="spec_title">
            <span class="spec-name-list">{{item.skuCatalogue}}</span><span style="font-weight: 500;">:</span>
          </td>
          <td class="spec-content" :style="specContentWidth">
              <div class="spec-item" v-if="selectInfo.attributeList">
                <span class="spec-name" :style="maxContentWidth"
                  v-for="(its,i) in item.attributeList" :key="i"
                  :class="[selectInfo.attributeList[index] == its ? 'active' :'unactive']"
                >
                  {{its}}
                </span>
              </div>
              <div class="spec-item" v-else>
                <span class="spec-name unactive" :style="maxContentWidth" v-for="(its,i) in item.attributeList" :key="i">{{its}}</span>
              </div>
              <div class="more">
                <img class="more-img" src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/icons/arrow_black.png" alt="">
              </div>
          </td>
        </tr>
      </table>
    </div>
    <!-- 商品参数 -->
    <div v-if="productParamInfoList && productParamInfoList.length > 0" class="goods-detail" ref="goods_detail">
      <div class="title-name">商品参数</div>
      <table class="goods-content" cellpadding="0" cellspacing="0" border="0">
        <tr class="table-tr" v-for="(item, index) in productParamInfoList" :key="index">
          <td class="name">{{item.name}}</td>
          <td class="value">{{item.value}}</td>
        </tr>
      </table>
    </div>
    <!-- 图文详情 -->
    <div v-if="showDetailImgList && showDetailImgList.length > 0"  class="img-text">
      <div class="title-name">图文描述</div>
      <div v-for="(img,index) in showDetailImgList"  :key="index">
        <img class="show-img"  v-lazy="img" alt="">
      </div>
    </div>
    <select-sku ref="select_sku" @skuChange='skuChange'></select-sku>
    <div class="bot">
      <div class="bot-item" @click="goChatContent">
        <img src="https://qianshoushoutest.oss-cn-hangzhou.aliyuncs.com/resources/images/seller/message.png" alt="">
        <div class="bot-title">客服</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getQssProductDetail } from '@/api/goods'
import { createChatRoom } from '@/api/seller'
import { getUserInfo } from '@/api/login'

import { Toast } from 'vant';
import SelectSku from "./components/select-sku.vue"
export default {
  components: {
    SelectSku
  },
  data() {
    return {
      current:0,
      // 列表2
      skuGoodsInfo:{},
      // 列表1
      goodsInfo:{},
      selectInfo:{},
      // 选中的信息，用来回显价格
      skuDetailInfo:{},
      // 最初的sku列表
      skuList:[],
      // 规格宽度
      contentWidth:'',
      userInfo: {},
    }
  },
  computed:{
    specContentWidth() {
      return `width:${this.contentWidth}px`
    },
    maxContentWidth() {
      return `max-width:${this.contentWidth - 80 }px`
    },
    // 轮播图
    showSkuImgList(){
      if(this.skuGoodsInfo.selectedSellerProductSkuNo){
        return this.selectInfo.carouselFigureUrlList
      }
      return this.skuGoodsInfo.carouselFigureUrlList
    },
    // 轮播图数量
    imgNumber() {
      if( this.showSkuImgList && this.showSkuImgList.length > 0){
        return this.showSkuImgList.length
      }
    },
    // 商品参数
    productParamInfoList(){
      if(this.skuGoodsInfo.selectedSellerProductSkuNo){
        return this.selectInfo.sellerProductParamInfoList
      }
      return this.skuGoodsInfo.sellerProductParamInfoList
    },
    // 图文详情
    showDetailImgList(){
      if(this.skuGoodsInfo.selectedSellerProductSkuNo){
        return this.selectInfo.sellerProductDetailPicUrlList
      }
      return this.skuGoodsInfo.sellerProductDetailPicUrlList
    },
    // 价格
    showPrice(){
    return  this.skuDetailInfo.price ? this.skuDetailInfo.price : this.skuGoodsInfo.sellerProductAmount
    }
  },

  created(){
    this.getProductDetail()
    const token = localStorage.getItem('token')
    if(token) {
      this.getUserInfo()
    }
  },
  methods:{
    async getProductDetail(){
      const params = {
        ...this.$route.query
      }
      const res = await getQssProductDetail(params)
      this.goodsInfo = res.mdata
      this.skuList = this.goodsInfo.sellerProductSkuDisplayDtoList
      this.skuGoodsInfo = JSON.parse(JSON.stringify(this.goodsInfo))
      this.skuList =JSON.parse(JSON.stringify(this.goodsInfo.sellerProductSkuDisplayDtoList))
      this.showSpecName()
      this.selectValue()
    },
  deepClone(source){
    const target = {};
    for (const i in source) {
      if (source.hasOwnProperty(i)
        && target[i] === 'object') {
        target[i] = deepClone(source[i]); // 注意这里
      } else {
        target[i] = source[i];
      }
    }
    return target;
  },
    // 计算显示规格值的宽度
    specWidth(){
      this.$nextTick(()=>{
        this.contentWidth = (this.$refs.goods_detail.clientWidth - this.$refs.spec_title[0].clientWidth)
      })
    },

    // 如果规格名超过10个字节。只显示10个
    showSpecName(){
      if(this.skuGoodsInfo.sellerProductSkuDisplayDtoList){
        this.skuGoodsInfo.sellerProductSkuDisplayDtoList.forEach(el=>{
          return el.skuCatalogue = this.reBytesStr(el.skuCatalogue,10)
        })
      }
      this.specWidth()
    },

    // 按字节截取指定长度字符串
    reBytesStr(str,len){
      if((!str && typeof(str) != 'undefined')) {
					return '';
				}
				var num = 0;
				var str1 = str;
				var str = '';
				for(var i = 0, lens = str1.length; i < lens; i++) {
					num += ((str1.charCodeAt(i) > 255) ? 2 : 1);
					if(num > len) {
						break;
					} else {
						str = str1.substring(0, i + 1);
					}
				}
				return str;
    },
    selectValue(){
      // 如果存在选中的sku编号，执行
      if(!this.skuGoodsInfo.selectedSellerProductSkuNo){
        this.skuGoodsInfo.sellerProductSkuDisplayDtoList = this.skuList
        this.selectInfo = {}
        return
      }
      // 选中的参数
      this.selectInfo = this.skuGoodsInfo.sellerProductSkuChooseDtoList.find(el=>{
        return el.skuNo == this.skuGoodsInfo.selectedSellerProductSkuNo
      })
      // 如果选中的参数存在，执行
      if(!this.selectInfo.attributeList){
        return
      }
      // 选中的参数排到第一位
      this.skuGoodsInfo.sellerProductSkuDisplayDtoList.forEach((el,index)=>{
        el.attributeList.find((item,i)=>{
          if(item == this.selectInfo.attributeList[index]){
            el.attributeList.unshift(el.attributeList.splice(i,1)[0])
            return
          }
        })
      })

    },
    onChange(index){
      this.current = index
    },
    selectSkuSpec(){
      const params = {
        goodsInfo: this.goodsInfo,
        selectInfo: this.selectInfo,
      }
      this.$refs.select_sku.changeShow(params)
    },
    skuChange(obj){
      this.skuDetailInfo = obj
      this.skuGoodsInfo.selectedSellerProductSkuNo = obj.skuNo || ''
      this.selectValue()
    },
    // 去往聊天
    async goChatContent() {

      // 创建聊天室
      const params = {
        operateEntityType: 0,
        type: 0,
        sellerProductNo: this.$route.query.productNo
      }
      try {
        const res = await createChatRoom(params)
        this.$router.push({
          name: 'chatContent',
          query: {
            chatRoomNo: res.mdata.chatRoomNo,
            entityType: 0,
            entityNo: this.userInfo.number || ''
          }
        })
      } catch (error) {
        Toast('操作失败')
      }

    },
    async getUserInfo() {
      const res = await getUserInfo()
      this.userInfo = res.mdata.user
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  padding-bottom: 100px;
}
.my-swipe {
  width: 100vw;
}
.my-swipe .van-swipe-item {
  .swipe-image{
    width: 100vw;
    height: 100vw;
    object-fit:contain;
  }
}
.custom-indicator{
  position: absolute;
  right: 30px;
  bottom: 30px;
  padding: 6px 20px;
  font-size: 24px;
  border-radius: 30px;
  color: #eee;
  background: rgba(0, 0, 0, 0.5);
}
.goods-title{
  margin: 30px;
  .title{
    font-size:36px;
    font-weight:bold;
    word-break:break-all;
    padding-bottom: 30px;
  }
  .show-price{
    display: flex;
    font-size:54px;
    color: #f23e7e;
    padding-bottom: 30px;
    font-weight: bold;
    .pr{
      font-size: 30px;
      margin-top: 22px;
      margin-right: 5px;
    }
  }
  .spec-detail{
    font-size: 30px;
    .table-tr{
      height: 62px;
      .spec-title{
        white-space:nowrap;
        padding-right: 16px;
        // vertical-align: middle;
        .spec-name-list{
          height:50px;
          display: inline-block;
          width: 95%;
          text-align-last: justify;
        }
      }
      .spec-content{
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        .spec-item{
          height: 52px;
          .spec-name{
            margin-top: 2px;
            display: inline-block;
            margin-right: 16px;
            padding: 2px 10px;
            min-width: 60px;
            border-radius: 12px;
            text-align: center;
            white-space:nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        .more{
          .more-img{
            width:36px;
            height:36px;
            padding: 6px 16px 6px 8px;
            background-color: #eee;
            border-radius: 16px;
          }

        }
      }
    }
  }
}

.goods-detail{
  font-size: 28px;
  margin: 30px;
  border-collapse: collapse;
  border-spacing:0;
  .goods-content{
    width: 100%;
    border-collapse: collapse;
    .table-tr{
      .name,
      .value {
        vertical-align: baseline;
        padding: 16px;
        border: 1px solid #ccc;
        vertical-align: middle;
      }
      .name{
        width: 170px;
      }
    }

  }
}

.img-text{
  .title-name{
    margin: 30px;
  }
  .show-img{
    margin-top: -8px;
    width: 100vw;
    object-fit: contain;
  }
}

.goods-detail,
.img-text{
  &::before{
    content: "";
    display: block;
    width: 100vw;
    height: 16px;
    background-color: #eee;
    margin-bottom: 30px;
    margin-left: -30px;
  }
}


.title-name{
  font-weight: bold;
  border-left: 6px solid #fb2776;
  padding-left: 16px;
  margin-bottom: 20px;
}

.unactive{
  color: #101010;
  background-color: #eee;
  border: 1px solid #e8e8e8 ;
}
.active{
  color:#F23E7E ;
  background-color: rgba(251,39,118,0.1) ;
  border: 1px solid #F23E7E ;
}
.bot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: #fff;
  display: flex;
  align-items: center;
  font-size: 12px;
  padding: 0 20px;
  box-sizing: border-box;
  img {
    width: 40px;
    height: 40px;
  }
  &-item {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  &-title {
    font-size: 20px;
    margin-top: 10px;
  }
}
</style>
